import React, { useState, useEffect } from 'react';
import { 
  Menu, X, Lock, LayoutDashboard, LogOut, 
  Plus, Edit, Trash2, Camera, MapPin, Home, 
  Building2, MonitorPlay, PaintBucket, Hotel, 
  ChevronRight, PlayCircle, Image as ImageIcon, 
  FileText, Sun, Moon, ArrowRight, Users, Eye, Trophy,
  MessageSquare, Type, Settings, Sparkles, Loader2, Save
} from 'lucide-react';

// --- 1. DICTIONNAIRE DE TRADUCTION (i18n) ---
const dict = {
  fr: {
    seo_title: "Eureca3D | Visite virtuelle Algerie | Immobilier 3D",
    seo_desc: "Leader de la visite virtuelle en Algérie. Boostez vos annonces immobilières : Appartement Haut standing, Villa, Hotel, Restaurant. Visite 360 et VR 3D.",
    nav_home: "Accueil",
    nav_services: "Solutions",
    nav_portfolio: "Réalisations",
    nav_blog: "Blog",
    nav_contact: "Contact",
    admin_login: "Espace Admin",
    hero_badge: "L'écosystème 3D Immobilier",
    hero_title: "Créez une expérience client 100% digitale",
    hero_subtitle: "Projetez vos clients dans le bâtiment. Solutions de visites virtuelles 360° et modélisations 3D pour l'immobilier, l'hôtellerie et l'industrie en Algérie.",
    hero_cta: "Découvrir nos solutions",
    partners_title: "Ils nous font confiance et témoignent",
    services_title: "Nos solutions s'adaptent à votre marché",
    services_subtitle: "Eureca3D présente le premier écosystème de solutions immersives pour piloter simultanément votre activité de vente et marketing.",
    srv_1: "Promotion Immobilière",
    srv_1_desc: "Vendez sur plan grâce à l'immersion totale en réalité virtuelle 360°.",
    srv_2: "Agences Immobilières",
    srv_2_desc: "Mettez en valeur les biens à la vente et accélérez vos transactions.",
    srv_3: "Architecture & Design",
    srv_3_desc: "Visualisation ultra-réaliste pour les projets de décoration d'intérieur.",
    srv_4: "Hôtellerie & Commerces",
    srv_4_desc: "Solutions adaptées pour Hôtels de luxe, Restaurants et visibilité Google Street View.",
    portfolio_title: "Une plateforme globale accélératrice de vente",
    portfolio_subtitle: "Explorez nos dernières réalisations immersives",
    blog_title: "Actualités & Conseils",
    blog_subtitle: "Découvrez les dernières tendances de la visite virtuelle",
    btn_visit: "Explorer en 3D",
    stat_1: "Projets Réalisés",
    stat_2: "Visites Virtuelles",
    stat_3: "Clients Satisfaits",
    footer_desc: "Créateur d'expériences immersives en Algérie. Visite virtuelle, modélisation 3D et solutions VR pour l'immobilier.",
    seo_keywords: "Mots-clés SEO : Visite virtuelle Algerie, Immobilier, Appartement Haut standing, Villa, Hotel, Restaurant.",
    dashboard_title: "Tableau de Bord Eureca3D",
    tab_portfolio: "Portfolio",
    tab_blog: "Blog",
    add_project: "Ajouter un projet",
    login_title: "Connexion Admin",
    login_btn: "Se connecter",
  },
  en: {
    seo_title: "Eureca3D | Virtual Tour Algeria | 3D Real Estate",
    seo_desc: "Leader in virtual tours in Algeria. Boost your real estate listings: Luxury Apartments, Villas, Hotels, Restaurants. 360 & VR 3D tours.",
    nav_home: "Home",
    nav_services: "Solutions",
    nav_portfolio: "Portfolio",
    nav_blog: "Blog",
    nav_contact: "Contact",
    admin_login: "Admin Area",
    hero_badge: "The 3D Real Estate Ecosystem",
    hero_title: "Create a 100% digital customer experience",
    hero_subtitle: "Project your clients into the building. 360° virtual tours and 3D modeling solutions for real estate, hospitality, and industry in Algeria.",
    hero_cta: "Discover our solutions",
    partners_title: "They trust us and testify",
    services_title: "Our solutions adapt to your market",
    services_subtitle: "Eureca3D presents the first ecosystem of immersive solutions to simultaneously manage your sales and marketing activities.",
    srv_1: "Real Estate Development",
    srv_1_desc: "Sell off-plan with total immersion in 360° virtual reality.",
    srv_2: "Real Estate Agencies",
    srv_2_desc: "Showcase properties for sale and accelerate your transactions.",
    srv_3: "Architecture & Design",
    srv_3_desc: "Ultra-realistic visualization for interior decoration projects.",
    srv_4: "Hospitality & Retail",
    srv_4_desc: "Tailored solutions for Luxury Hotels, Restaurants, and Google Street View visibility.",
    portfolio_title: "A global platform to accelerate sales",
    portfolio_subtitle: "Explore our latest immersive projects",
    blog_title: "News & Tips",
    blog_subtitle: "Discover the latest trends in virtual tours",
    btn_visit: "Explore in 3D",
    stat_1: "Completed Projects",
    stat_2: "Virtual Tours",
    stat_3: "Satisfied Clients",
    footer_desc: "Creator of immersive experiences in Algeria. Virtual tours, 3D modeling, and VR solutions for real estate.",
    seo_keywords: "SEO Keywords: Visite virtuelle Algerie, Immobilier, Appartement Haut standing, Villa, Hotel, Restaurant.",
    dashboard_title: "Eureca3D Dashboard",
    tab_portfolio: "Portfolio",
    tab_blog: "Blog",
    add_project: "Add Project",
    login_title: "Admin Login",
    login_btn: "Login",
  },
  ar: {
    seo_title: "يوريكا 3D | جولة افتراضية الجزائر | عقارات 3D",
    seo_desc: "الرائد في الجولات الافتراضية في الجزائر. عزز إعلاناتك العقارية: شقق فاخرة، فيلات، فنادق، مطاعم.",
    nav_home: "الرئيسية",
    nav_services: "حلولنا",
    nav_portfolio: "أعمالنا",
    nav_blog: "المدونة",
    nav_contact: "اتصل بنا",
    admin_login: "دخول الإدارة",
    hero_badge: "النظام البيئي العقاري ثلاثي الأبعاد",
    hero_title: "قم بإنشاء تجربة عملاء رقمية 100٪",
    hero_subtitle: "انقل عملائك إلى داخل المبنى. حلول الجولات الافتراضية 360 درجة والنماذج ثلاثية الأبعاد للعقارات والفنادق والصناعة في الجزائر.",
    hero_cta: "اكتشف حلولنا",
    partners_title: "يثقون بنا ويشهدون لنا",
    services_title: "حلولنا تتكيف مع سوقك",
    services_subtitle: "تقدم يوريكا 3D أول نظام بيئي للحلول الغامرة لإدارة مبيعاتك وأنشطتك التسويقية في وقت واحد.",
    srv_1: "التطوير العقاري",
    srv_1_desc: "البيع على المخطط بفضل الانغماس التام في الواقع الافتراضي 360 درجة.",
    srv_2: "الوكالات العقارية",
    srv_2_desc: "إبراز العقارات المعروضة للبيع وتسريع عملياتك.",
    srv_3: "الهندسة المعمارية والتصميم",
    srv_3_desc: "رؤية واقعية جداً لمشاريع الديكور الداخلي.",
    srv_4: "الفنادق والمتاجر",
    srv_4_desc: "حلول مناسبة للفنادق الفاخرة، المطاعم، والظهور على خرائط جوجل.",
    portfolio_title: "منصة عالمية لتسريع المبيعات",
    portfolio_subtitle: "استكشف أحدث مشاريعنا الغامرة",
    blog_title: "أخبار ونصائح",
    blog_subtitle: "اكتشف أحدث الاتجاهات في الجولات الافتراضية",
    btn_visit: "استكشف بتقنية 3D",
    stat_1: "مشاريع منجزة",
    stat_2: "جولة افتراضية",
    stat_3: "عملاء راضون",
    footer_desc: "صناع التجارب الغامرة في الجزائر. جولات افتراضية وتصميم ثلاثي الأبعاد.",
    seo_keywords: "الكلمات المفتاحية: Visite virtuelle Algerie, Immobilier, Appartement Haut standing, Villa, Hotel, Restaurant.",
    dashboard_title: "لوحة تحكم يوريكا 3D",
    tab_portfolio: "أعمالنا",
    tab_blog: "المدونة",
    add_project: "إضافة مشروع",
    login_title: "تسجيل دخول الإدارة",
    login_btn: "دخول",
  }
};

// --- 2. DONNÉES INITIALES (Mock Data) ---
const initialPortfolio = [
  {
    id: 1,
    title: "Djennah Rekhila - Promotion",
    subtitle: "Drone & Incrustation 3D Aérienne",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=800",
    url: "https://eureca3d.com/rekhilapromotion/djennah/"
  },
  {
    id: 2,
    title: "Appartements Témoins F2-F3-F4",
    subtitle: "Djennah Promotion - Duplex Immersion",
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80&w=800",
    url: "https://eureca3d.com/rekhilapromotion/djennahapartments/#media=2&yaw=160.43&pitch=1.62&fov=110.00"
  },
  {
    id: 3,
    title: "Résidence Silva Cheraga",
    subtitle: "Home Label - Appartement Haut standing",
    image: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&q=80&w=800",
    url: "https://sakan360.com/tours/residencesilva/"
  },
  {
    id: 4,
    title: "Mirage Landmark Annaba",
    subtitle: "Visite Virtuelle Résidentielle",
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&q=80&w=800",
    url: "https://sakan360.com/tours/miragecity/"
  },
  {
    id: 5,
    title: "Interior Design VR Immersion",
    subtitle: "Projet Décoration d'Intérieur TBDG",
    image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&q=80&w=800",
    url: "https://eureca3d.com/tbdg/"
  },
  {
    id: 6,
    title: "Appartement Témoin BM Promotion",
    subtitle: "Esquisse & Vue Aérienne 360",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80&w=800",
    url: "https://app.sakan360.com/viewer/bmapptemoins?room=1144"
  },
  {
    id: 7,
    title: "Marassi al Bahrain",
    subtitle: "Marassi Vista - Visite 3D",
    image: "https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&q=80&w=800",
    url: "https://app.sakan360.com/viewer/marassi-vista"
  },
  {
    id: 8,
    title: "Kitchen Showroom Dubai",
    subtitle: "Immobilier & Design Commercial",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&q=80&w=800",
    url: "https://sakan360.com/tours/bhd/"
  }
];

const initialClients = [
  { id: 1, name: "REKHILA", logo: "", style: "font-black" },
  { id: 2, name: "BM Promo", logo: "", style: "font-serif italic" },
  { id: 3, name: "Mirage Landmark", logo: "", style: "font-bold" },
  { id: 4, name: "TBDG", logo: "", style: "font-light tracking-widest" }
];

const initialTestimonials = [
  { 
    id: 1, 
    author: "Claire D.", 
    role: "Directrice Commerciale", 
    text: "Eureca3D a transformé notre façon de vendre sur plan. L'immersion est totale et nos clients sont conquis dès la première visite virtuelle." 
  },
  { 
    id: 2, 
    author: "Amine K.", 
    role: "Agent Immobilier", 
    text: "Depuis que nous utilisons ces visites 360, nos annonces reçoivent 3 fois plus de contacts qualifiés. Un outil devenu indispensable." 
  }
];

const initialBlogPosts = [
  {
    id: 1,
    lang: 'fr',
    topic: "L'impact de la réalité virtuelle sur l'immobilier en Algérie",
    content: "La réalité virtuelle (VR) et les visites 360° redéfinissent la manière dont les biens immobiliers sont présentés et vendus en Algérie. Fini le temps où de simples photos suffisaient à convaincre un acheteur potentiel.\n\nGrâce à des entreprises comme Eureca3D, les promoteurs et agents immobiliers peuvent désormais offrir une immersion totale. Les clients peuvent explorer chaque recoin d'un appartement ou d'une villa de haut standing depuis leur canapé. Cela permet non seulement de gagner un temps précieux en évitant les visites physiques inutiles, mais aussi de créer un coup de cœur instantané.\n\nEn résumé, intégrer la visite virtuelle à vos annonces n'est plus un luxe, mais une nécessité pour se démarquer sur un marché concurrentiel.",
    date: "10/05/2026"
  },
  {
    id: 2,
    lang: 'en',
    topic: "The impact of virtual reality on real estate in Algeria",
    content: "Virtual reality (VR) and 360° tours are redefining the way real estate is presented and sold in Algeria. Gone are the days when simple photos were enough to convince a potential buyer.\n\nThanks to companies like Eureca3D, developers and real estate agents can now offer total immersion. Clients can explore every corner of a luxury apartment or villa from their couch. This not only saves valuable time by avoiding unnecessary physical visits but also creates an instant emotional connection.\n\nIn short, integrating virtual tours into your listings is no longer a luxury, but a necessity to stand out in a competitive market.",
    date: "05/10/2026"
  },
  {
    id: 3,
    lang: 'ar',
    topic: "تأثير الواقع الافتراضي على العقارات في الجزائر",
    content: "تعيد تقنية الواقع الافتراضي والجولات بزاوية 360 درجة تعريف طريقة عرض العقارات وبيعها في الجزائر. ولت الأيام التي كانت فيها الصور البسيطة كافية لإقناع المشتري المحتمل.\n\nبفضل شركات مثل يوريكا 3D، يمكن للمطورين ووكلاء العقارات الآن تقديم انغماس كامل. يمكن للعملاء استكشاف كل زاوية من شقة فاخرة أو فيلا وهم جالسون على أرائكهم. هذا لا يوفر الوقت الثمين عن طريق تجنب الزيارات المادية غير الضرورية فحسب، بل يخلق أيضًا ارتباطًا عاطفيًا فوريًا.\n\nباختصار، دمج الجولات الافتراضية في إعلاناتك لم يعد رفاهية، بل ضرورة للتميز في سوق تنافسي.",
    date: "2026/05/10"
  },
  {
    id: 4,
    lang: 'fr',
    topic: "L'impact de la visite virtuelle et de l'automatisation sur l'immobilier",
    content: "L'automatisation des processus de vente combinée aux visites virtuelles crée une synergie puissante pour le marché immobilier moderne.\n\nAu lieu d'organiser des dizaines de visites préliminaires, les agents immobiliers peuvent désormais qualifier leurs prospects grâce aux statistiques de visionnage des visites 360°. Les clients visitent les biens à distance 24h/24 et 7j/7, éliminant ainsi les contraintes de temps et de distance.\n\nEn automatisant la prise de rendez-vous uniquement pour les clients hautement intéressés (ceux qui ont passé du temps dans la visite virtuelle), les agences décuplent leur efficacité et augmentent drastiquement leur taux de conversion.",
    date: "12/05/2026"
  },
  {
    id: 5,
    lang: 'en',
    topic: "The impact of virtual tours and automation on real estate",
    content: "The automation of sales processes combined with virtual tours creates a powerful synergy for the modern real estate market.\n\nInstead of organizing dozens of preliminary visits, real estate agents can now qualify their prospects through 360° tour viewing statistics. Clients visit properties remotely 24/7, eliminating time and distance constraints.\n\nBy automating appointment scheduling only for highly interested clients (those who have spent time in the virtual tour), agencies multiply their efficiency and drastically increase their conversion rates.",
    date: "05/12/2026"
  },
  {
    id: 6,
    lang: 'ar',
    topic: "تأثير الجولات الافتراضية والأتمتة على العقارات",
    content: "تخلق أتمتة عمليات البيع جنبًا إلى جنب مع الجولات الافتراضية تآزرًا قويًا لسوق العقارات الحديث.\n\nبدلاً من تنظيم العشرات من الزيارات الأولية، يمكن لوكلاء العقارات الآن تأهيل عملائهم المحتملين من خلال إحصائيات مشاهدة الجولات بزاوية 360 درجة. يزور العملاء العقارات عن بُعد على مدار الساعة طوال أيام الأسبوع، مما يزيل قيود الوقت والمسافة.\n\nمن خلال أتمتة جدولة المواعيد فقط للعملاء المهتمين للغاية (أولئك الذين أمضوا وقتًا طويلاً في الجولة الافتراضية)، تضاعف الوكالات كفاءتها وتزيد من معدلات التحويل بشكل كبير.",
    date: "2026/05/12"
  }
];

// --- 3. COMPOSANT LOGO EURECA3D ---
const EurecaLogo = ({ className = "w-10 h-10" }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="100" rx="20" className="fill-[#0090FF] dark:fill-[#0090FF]" />
    <path d="M 25 55 L 50 35 L 75 55" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M 25 55 V 65 A 10 10 0 0 0 35 75 H 42" stroke="white" strokeWidth="6" strokeLinecap="round"/>
    <path d="M 75 55 V 65 A 10 10 0 0 1 65 75 H 58" stroke="white" strokeWidth="6" strokeLinecap="round"/>
    <path d="M 25 55 A 5 5 0 0 0 25 65" stroke="white" strokeWidth="6" strokeLinecap="round"/>
    <path d="M 75 55 A 5 5 0 0 1 75 65" stroke="white" strokeWidth="6" strokeLinecap="round"/>
    <circle cx="50" cy="55" r="7" stroke="white" strokeWidth="6"/>
    <path d="M 46 62 L 44 75 H 56 L 54 62" fill="white"/>
  </svg>
);

// --- 4. APPLICATION PRINCIPALE ---
export default function App() {
  // États Globaux
  const [lang, setLang] = useState('fr');
  const [theme, setTheme] = useState('light');
  const [view, setView] = useState('public');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  // Données Globales (Lifted State pour accès par PublicSite & AdminDashboard)
  const [contentDict, setContentDict] = useState(dict);
  const [portfolio, setPortfolio] = useState(initialPortfolio);
  const [clients, setClients] = useState(initialClients);
  const [testimonials, setTestimonials] = useState(initialTestimonials);
  const [blogPosts, setBlogPosts] = useState(initialBlogPosts);
  const [siteLogoUrl, setSiteLogoUrl] = useState("");

  const t = (key) => contentDict[lang][key] || key;
  const isRtl = lang === 'ar';

  // Rendu du Logo Dynamique
  const LogoRenderer = ({ className }) => {
    if (siteLogoUrl) {
      return <img src={siteLogoUrl} alt="Logo Eureca3D" className={`object-contain bg-white dark:bg-slate-900 ${className}`} />;
    }
    return <EurecaLogo className={className} />;
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.title = t('seo_title');
    document.documentElement.lang = lang;
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    if (theme === 'dark') document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
  }, [lang, theme]);

  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');

  // ==========================================
  // VUE : SITE PUBLIC
  // ==========================================
  const PublicSite = () => {
    const services = [
      { icon: <Building2 size={40} strokeWidth={1.5} />, title: t('srv_1'), desc: t('srv_1_desc') },
      { icon: <Home size={40} strokeWidth={1.5} />, title: t('srv_2'), desc: t('srv_2_desc') },
      { icon: <PaintBucket size={40} strokeWidth={1.5} />, title: t('srv_3'), desc: t('srv_3_desc') },
      { icon: <Hotel size={40} strokeWidth={1.5} />, title: t('srv_4'), desc: t('srv_4_desc') }
    ];

    return (
      <div className={`min-h-screen transition-colors duration-300 ${theme === 'dark' ? 'bg-slate-950 text-slate-200' : 'bg-slate-50 text-slate-800'} font-sans ${isRtl ? 'rtl' : 'ltr'}`} dir={isRtl ? 'rtl' : 'ltr'}>
        {/* NAVBAR */}
        <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 dark:bg-slate-900/95 backdrop-blur-md shadow-sm border-b border-slate-200 dark:border-slate-800 py-3' : 'bg-transparent py-5'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center">
              <div className="flex-shrink-0 flex items-center gap-3 cursor-pointer" onClick={() => setView('public')}>
                <LogoRenderer className="w-10 h-10 shadow-lg rounded-xl" />
                <span className={`text-2xl font-extrabold tracking-tight ${scrolled ? 'text-slate-900 dark:text-white' : 'text-white'}`}>
                  EURECA<span className="text-[#0090FF]">3D</span>
                </span>
              </div>

              <div className="hidden md:flex items-center space-x-8 rtl:space-x-reverse">
                <a href="#services" className={`font-semibold transition-colors hover:text-[#0090FF] ${scrolled ? 'text-slate-600 dark:text-slate-300' : 'text-white/90'}`}>{t('nav_services')}</a>
                <a href="#portfolio" className={`font-semibold transition-colors hover:text-[#0090FF] ${scrolled ? 'text-slate-600 dark:text-slate-300' : 'text-white/90'}`}>{t('nav_portfolio')}</a>
                <a href="#blog" className={`font-semibold transition-colors hover:text-[#0090FF] ${scrolled ? 'text-slate-600 dark:text-slate-300' : 'text-white/90'}`}>{t('nav_blog')}</a>
                
                <div className="flex items-center gap-4 border-l border-slate-300 dark:border-slate-700 pl-6 rtl:pr-6 rtl:pl-0 rtl:border-r rtl:border-l-0">
                  <button onClick={toggleTheme} className={`p-2 rounded-full transition-colors ${scrolled ? 'text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800' : 'text-white hover:bg-white/20'}`}>
                    {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
                  </button>
                  <div className={`flex items-center rounded-full p-1 border ${scrolled ? 'bg-slate-100 dark:bg-slate-800 border-slate-200 dark:border-slate-700' : 'bg-white/10 border-white/20'}`}>
                    {['fr', 'en', 'ar'].map(l => (
                      <button key={l} onClick={() => setLang(l)} className={`px-3 py-1 rounded-full text-xs font-bold uppercase transition-all ${lang === l ? 'bg-[#0090FF] text-white shadow-sm' : scrolled ? 'text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white' : 'text-white/70 hover:text-white'}`}>
                        {l}
                      </button>
                    ))}
                  </div>
                  <button onClick={() => setView('login')} className={`flex items-center gap-2 text-sm font-semibold px-5 py-2.5 rounded-full transition-all ${scrolled ? 'bg-slate-900 text-white hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100' : 'bg-white text-slate-900 hover:bg-slate-100 shadow-lg'}`}>
                    <Lock size={16} /> {t('admin_login')}
                  </button>
                </div>
              </div>

              <div className="md:hidden flex items-center gap-4">
                <button onClick={toggleTheme} className={scrolled ? 'text-slate-800 dark:text-white' : 'text-white'}>
                  {theme === 'light' ? <Moon size={24} /> : <Sun size={24} />}
                </button>
                <button onClick={() => setIsMenuOpen(!isMenuOpen)} className={`focus:outline-none ${scrolled ? 'text-slate-800 dark:text-white' : 'text-white'}`}>
                  {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="md:hidden bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 absolute w-full left-0 top-full shadow-xl">
              <div className="px-4 pt-2 pb-6 space-y-3">
                <a href="#services" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 text-lg font-medium text-slate-800 dark:text-slate-200 border-b border-slate-100 dark:border-slate-800">{t('nav_services')}</a>
                <a href="#portfolio" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 text-lg font-medium text-slate-800 dark:text-slate-200 border-b border-slate-100 dark:border-slate-800">{t('nav_portfolio')}</a>
                <a href="#blog" onClick={() => setIsMenuOpen(false)} className="block px-3 py-3 text-lg font-medium text-slate-800 dark:text-slate-200 border-b border-slate-100 dark:border-slate-800">{t('nav_blog')}</a>
                
                <div className="flex px-3 py-4 gap-2">
                  {['fr', 'en', 'ar'].map(l => (
                    <button key={l} onClick={() => {setLang(l); setIsMenuOpen(false)}} className={`flex-1 py-2 rounded-lg font-bold border ${lang === l ? 'bg-[#0090FF] border-[#0090FF] text-white' : 'border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400'}`}>
                      {l.toUpperCase()}
                    </button>
                  ))}
                </div>
                <button onClick={() => { setView('login'); setIsMenuOpen(false); }} className="w-full justify-center px-3 py-3 bg-slate-900 dark:bg-white text-white dark:text-slate-900 font-bold rounded-lg flex items-center gap-2">
                  <Lock size={18} /> {t('admin_login')}
                </button>
              </div>
            </div>
          )}
        </nav>

        {/* HERO SECTION */}
        <section className="relative min-h-[90vh] flex items-center pt-20 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&q=80" alt="Architecture" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-slate-900/60 dark:bg-slate-950/80 mix-blend-multiply"></div>
          </div>
          <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight drop-shadow-lg">{t('hero_title')}</h1>
            <p className="mt-6 text-xl md:text-2xl text-slate-100 max-w-3xl mx-auto mb-10 font-medium drop-shadow-md">{t('hero_subtitle')}</p>
            <a href="#portfolio" className="inline-flex items-center justify-center px-10 py-5 text-lg font-bold rounded-full text-white bg-[#0090FF] hover:bg-blue-600 shadow-xl shadow-blue-500/30 transform hover:-translate-y-1 transition-all">{t('hero_cta')}</a>
          </div>
        </section>

        {/* PARTNERS BANNER */}
        <section className={`py-10 border-b transition-colors ${theme === 'dark' ? 'bg-slate-900 border-slate-800' : 'bg-white border-slate-200'}`}>
          <div className="max-w-7xl mx-auto px-4 text-center">
            <p className={`text-sm font-bold uppercase tracking-wider mb-6 ${theme === 'dark' ? 'text-slate-500' : 'text-slate-400'}`}>{t('partners_title')}</p>
            <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500">
              {clients.map(client => (
                client.logo ? (
                  <img key={client.id} src={client.logo} alt={client.name} title={client.name} className="h-12 md:h-16 object-contain" />
                ) : (
                  <span key={client.id} className={`text-2xl ${client.style} ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>
                    {client.name}
                  </span>
                )
              ))}
            </div>
          </div>
        </section>

        {/* SERVICES SECTION */}
        <section id="services" className={`py-24 transition-colors ${theme === 'dark' ? 'bg-slate-950' : 'bg-slate-50'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center max-w-4xl mx-auto mb-20">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-100 dark:bg-blue-900/30 text-[#0090FF] mb-6">
                <MonitorPlay size={32} />
              </div>
              <h2 className={`text-3xl md:text-5xl font-extrabold mb-6 tracking-tight ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{t('services_title')}</h2>
              <p className={`text-xl ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>{t('services_subtitle')}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
              {services.map((srv, idx) => (
                <div key={idx} className="flex flex-col items-center text-center group">
                  <div className={`w-24 h-24 rounded-full flex items-center justify-center mb-6 transition-all duration-300 group-hover:scale-110 ${theme === 'dark' ? 'bg-slate-900 text-[#0090FF] shadow-[0_0_30px_rgba(0,144,255,0.15)]' : 'bg-white text-[#0090FF] shadow-xl shadow-blue-500/10'}`}>
                    {srv.icon}
                  </div>
                  <h3 className={`text-xl font-bold mb-3 ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{srv.title}</h3>
                  <p className={`leading-relaxed ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>{srv.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* PORTFOLIO SECTION */}
        <section id="portfolio" className={`py-24 transition-colors ${theme === 'dark' ? 'bg-slate-900' : 'bg-white'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <span className="text-[#0090FF] font-bold tracking-wider uppercase text-sm mb-2 block">Portfolio</span>
              <h2 className={`text-3xl md:text-5xl font-extrabold mb-4 tracking-tight ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{t('portfolio_title')}</h2>
              <p className={`text-lg ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>{t('portfolio_subtitle')}</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 gap-8">
              {portfolio.map((item) => (
                <a href={item.url} target="_blank" rel="noopener noreferrer" key={item.id} className="group relative rounded-3xl overflow-hidden block transform transition-all duration-500 hover:-translate-y-2 shadow-lg hover:shadow-2xl">
                  <div className="aspect-[4/3] relative">
                    <img src={item.image} alt={item.title} className="object-cover w-full h-full transform transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/20 to-transparent opacity-80"></div>
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-slate-900/40 backdrop-blur-sm">
                      <div className="bg-[#0090FF] text-white rounded-full p-4 transform scale-50 group-hover:scale-100 transition-transform duration-300"><PlayCircle size={32} /></div>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 w-full p-8 text-left">
                    <p className="text-[#0090FF] text-sm font-bold tracking-wider uppercase mb-2">{item.subtitle}</p>
                    <h3 className="text-2xl font-bold text-white leading-tight">{item.title}</h3>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        {/* TESTIMONIALS SECTION */}
        <section className={`py-24 border-t transition-colors ${theme === 'dark' ? 'bg-slate-950 border-slate-800' : 'bg-slate-50 border-slate-200'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <MessageSquare size={40} className="mx-auto text-[#0090FF] mb-6 opacity-80" />
              <h2 className={`text-3xl md:text-4xl font-extrabold mb-4 tracking-tight ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>Ce que disent nos clients</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {testimonials.map((testi) => (
                <div key={testi.id} className={`p-8 rounded-3xl relative ${theme === 'dark' ? 'bg-slate-900' : 'bg-white shadow-xl shadow-slate-200/50'}`}>
                  <p className={`text-lg italic mb-6 leading-relaxed ${theme === 'dark' ? 'text-slate-300' : 'text-slate-600'}`}>"{testi.text}"</p>
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#0090FF] to-blue-400 flex items-center justify-center text-white font-bold text-xl">{testi.author.charAt(0)}</div>
                    <div>
                      <h4 className={`font-bold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{testi.author}</h4>
                      <p className={`text-sm ${theme === 'dark' ? 'text-[#0090FF]' : 'text-[#0090FF]'}`}>{testi.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* BLOG SECTION */}
        {blogPosts.filter(p => p.lang === lang).length > 0 && (
          <section id="blog" className={`py-24 transition-colors ${theme === 'dark' ? 'bg-slate-900' : 'bg-white'}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <span className="text-[#0090FF] font-bold tracking-wider uppercase text-sm mb-2 block">Le Blog Eureca3D</span>
                <h2 className={`text-3xl md:text-5xl font-extrabold mb-4 tracking-tight ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{t('blog_title')}</h2>
                <p className={`text-lg ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>{t('blog_subtitle')}</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                {blogPosts.filter(p => p.lang === lang).map((post) => (
                  <div key={post.id} className={`p-8 rounded-3xl border transition-all duration-300 hover:shadow-xl flex flex-col h-full ${theme === 'dark' ? 'bg-slate-800 border-slate-700 hover:border-blue-500/50' : 'bg-slate-50 border-slate-200 hover:border-blue-300'}`}>
                    <div className="flex justify-between items-center mb-6">
                      <span className={`text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full ${theme === 'dark' ? 'bg-[#0090FF]/20 text-[#0090FF]' : 'bg-blue-100 text-[#0090FF]'}`}>Article</span>
                      <span className={`text-sm font-semibold ${theme === 'dark' ? 'text-slate-400' : 'text-slate-500'}`}>{post.date}</span>
                    </div>
                    <h3 className={`text-2xl font-bold mb-4 leading-tight ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{post.topic}</h3>
                    <div className={`text-base leading-relaxed whitespace-pre-wrap flex-1 ${theme === 'dark' ? 'text-slate-300' : 'text-slate-600'}`}>
                      {post.content}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* STATS SECTION */}
        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0">
            <img src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&q=80" alt="Stats bg" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-slate-900/80"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 text-center">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              <div>
                <Trophy size={48} className="mx-auto text-[#0090FF] mb-4" />
                <div className="text-5xl font-extrabold text-white mb-2">150+</div>
                <div className="text-slate-300 font-medium text-lg uppercase tracking-wider">{t('stat_1')}</div>
              </div>
              <div>
                <Eye size={48} className="mx-auto text-[#0090FF] mb-4" />
                <div className="text-5xl font-extrabold text-white mb-2">50k+</div>
                <div className="text-slate-300 font-medium text-lg uppercase tracking-wider">{t('stat_2')}</div>
              </div>
              <div>
                <Users size={48} className="mx-auto text-[#0090FF] mb-4" />
                <div className="text-5xl font-extrabold text-white mb-2">200+</div>
                <div className="text-slate-300 font-medium text-lg uppercase tracking-wider">{t('stat_3')}</div>
              </div>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className={`py-16 border-t transition-colors ${theme === 'dark' ? 'bg-slate-950 border-slate-900' : 'bg-slate-100 border-slate-200'}`}>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center mb-12">
              <div className="flex items-center gap-3">
                <LogoRenderer className="w-12 h-12 rounded-xl" />
                <span className={`text-3xl font-extrabold tracking-tight ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>
                  EURECA<span className="text-[#0090FF]">3D</span>
                </span>
              </div>
              <div className="md:col-span-2 flex flex-col md:flex-row gap-6 md:justify-end items-center">
                <p className={`font-semibold ${theme === 'dark' ? 'text-slate-300' : 'text-slate-600'}`}>Prêt à révolutionner vos ventes ?</p>
                <a href="mailto:contact@eureca3d.com" className="bg-slate-900 dark:bg-white text-white dark:text-slate-900 px-8 py-3 rounded-full font-bold hover:shadow-lg transition-all">Contactez-nous</a>
              </div>
            </div>
            <div className={`text-xs mt-12 pt-8 border-t text-justify ${theme === 'dark' ? 'text-slate-600 border-slate-800' : 'text-slate-400 border-slate-300'}`}>
              <p>
                <strong>{t('seo_keywords')}</strong> Eureca3D est la référence pour la <strong>Visite virtuelle Algerie</strong>. 
                Que vous soyez dans le secteur de l'<strong>Immobilier</strong> pour mettre en valeur un <strong>Appartement Haut standing</strong> 
                ou une somptueuse <strong>Villa</strong>, nos solutions 3D s'adaptent à vos besoins. 
              </p>
            </div>
          </div>
        </footer>
      </div>
    );
  };

  // ==========================================
  // VUE : LOGIN ADMIN
  // ==========================================
  const AdminLogin = () => {
    const [errorMsg, setErrorMsg] = useState("");

    const handleLogin = (e) => {
      e.preventDefault();
      const email = e.target.email.value;
      const password = e.target.password.value;

      if (email === "aissaoui.tayeb@eureca3d.com" && password === "Tester@2026") {
        setErrorMsg("");
        setView('admin');
      } else {
        setErrorMsg(lang === 'fr' ? "Identifiants incorrects" : lang === 'en' ? "Incorrect credentials" : "بيانات الاعتماد غير صحيحة");
      }
    };

    return (
      <div className={`min-h-screen flex items-center justify-center p-4 transition-colors ${theme === 'dark' ? 'bg-slate-950 text-white' : 'bg-slate-100 text-slate-900'} ${isRtl ? 'rtl' : 'ltr'}`} dir={isRtl ? 'rtl' : 'ltr'}>
        <div className={`p-10 rounded-3xl w-full max-w-md shadow-2xl ${theme === 'dark' ? 'bg-slate-900 shadow-blue-900/20' : 'bg-white shadow-slate-200/50'}`}>
          <div className="text-center mb-8 flex flex-col items-center">
            <LogoRenderer className="w-16 h-16 mb-6 shadow-xl rounded-2xl" />
            <h2 className="text-2xl font-extrabold">{t('login_title')}</h2>
          </div>
          <form onSubmit={handleLogin} className="space-y-6">
            {errorMsg && (
              <div className="p-3 bg-red-500/10 border border-red-500/50 text-red-500 rounded-xl text-sm font-bold text-center">
                {errorMsg}
              </div>
            )}
            <div>
              <label className={`block text-sm font-bold mb-2 ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>Email</label>
              <input type="email" name="email" required placeholder="nom@exemple.com" className={`w-full rounded-xl px-4 py-3 font-medium focus:outline-none focus:ring-2 focus:ring-[#0090FF] transition-all ${theme === 'dark' ? 'bg-slate-800 text-white placeholder-slate-500' : 'bg-slate-50 text-slate-900 border border-slate-200'}`} />
            </div>
            <div>
              <label className={`block text-sm font-bold mb-2 ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>{lang === 'fr' ? 'Mot de passe' : lang === 'en' ? 'Password' : 'كلمة المرور'}</label>
              <input type="password" name="password" required placeholder="••••••••" className={`w-full rounded-xl px-4 py-3 font-medium focus:outline-none focus:ring-2 focus:ring-[#0090FF] transition-all ${theme === 'dark' ? 'bg-slate-800 text-white placeholder-slate-500' : 'bg-slate-50 text-slate-900 border border-slate-200'}`} />
            </div>
            <button type="submit" className="w-full bg-[#0090FF] hover:bg-blue-600 text-white font-bold py-4 rounded-xl transition-all transform hover:-translate-y-1 shadow-lg shadow-blue-500/30">
              {t('login_btn')}
            </button>
          </form>
          <div className="mt-8 text-center">
            <button onClick={() => setView('public')} className={`text-sm font-semibold hover:text-[#0090FF] transition-colors ${theme === 'dark' ? 'text-slate-400' : 'text-slate-500'}`}>
              &larr; {lang === 'fr' ? 'Retour au site' : lang === 'en' ? 'Back to site' : 'العودة للموقع'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  // ==========================================
  // VUE : TABLEAU DE BORD ADMIN
  // ==========================================
  const AdminDashboard = () => {
    const [activeTab, setActiveTab] = useState('portfolio');
    
    // API Gemini
    const apiKey = "AIzaSyAova8_APJjol6Fdff4S6GCx7-YqZopuS4"; 
    const [isGeneratingBlog, setIsGeneratingBlog] = useState(false);
    const [blogTopic, setBlogTopic] = useState("");
    const [optimizingKey, setOptimizingKey] = useState(null);

    // État de la fenêtre Modale (Pop-up Form)
    const [modalConfig, setModalConfig] = useState({ isOpen: false, type: '', data: null });

    const callGeminiAPI = async (prompt) => {
      const url = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-preview-09-2025:generateContent?key=${apiKey}`;
      const payload = { contents: [{ parts: [{ text: prompt }] }] };
      const delays = [1000, 2000, 4000, 8000, 16000];

      for (let i = 0; i < delays.length + 1; i++) {
        try {
          const response = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
          if (!response.ok) throw new Error(`HTTP error!`);
          const data = await response.json();
          return data.candidates?.[0]?.content?.parts?.[0]?.text || "";
        } catch (error) {
          if (i === delays.length) return "Erreur lors de la génération. Veuillez réessayer.";
          await new Promise(res => setTimeout(res, delays[i]));
        }
      }
    };

    const handleGenerateBlog = async () => {
      if (!blogTopic.trim()) return;
      setIsGeneratingBlog(true);
      const prompt = `Tu es un expert en marketing immobilier travaillant pour "Eureca3D". Rédige un article de blog professionnel sur : "${blogTopic}". Rédige en ${lang === 'en' ? 'anglais' : lang === 'ar' ? 'arabe' : 'français'}. Formate le texte simplement avec des sauts de ligne.`;
      const generatedContent = await callGeminiAPI(prompt);
      const newPost = { 
        id: Date.now(), 
        lang: lang, // On enregistre la langue active au moment de la génération
        topic: blogTopic, 
        content: generatedContent, 
        date: new Date().toLocaleDateString(lang === 'ar' ? 'ar-DZ' : lang === 'en' ? 'en-US' : 'fr-FR') 
      };
      setBlogPosts([newPost, ...blogPosts]); // On met à jour l'état global
      setBlogTopic("");
      setIsGeneratingBlog(false);
    };

    const handleOptimizeText = async (key, currentText) => {
      setOptimizingKey(key);
      const prompt = `Tu es expert SEO pour Eureca3D. Réécris ce texte pour le rendre plus vendeur. Langue : ${lang}. Ne renvoie QUE le texte réécrit.\nTexte original: "${currentText}"`;
      const optimizedText = await callGeminiAPI(prompt);
      if (!optimizedText.startsWith("Erreur")) handleTextUpdate(key, optimizedText.trim());
      setOptimizingKey(null);
    };

    const handleTextUpdate = (key, value) => {
      setContentDict(prev => ({ ...prev, [lang]: { ...prev[lang], [key]: value } }));
    };

    // Gestion de la Modale CRUD
    const openModal = (type, data = null) => {
      // Préparer les données par défaut si c'est un ajout
      let defaultData = {};
      if (!data) {
        if (type === 'portfolio') defaultData = { title: '', subtitle: '', image: '', url: '' };
        if (type === 'clients') defaultData = { name: '', logo: '', style: 'font-bold' };
        if (type === 'temoignages') defaultData = { author: '', role: '', text: '' };
      } else {
        defaultData = { ...data };
      }
      setModalConfig({ isOpen: true, type, data: defaultData });
    };

    const closeModal = () => setModalConfig({ isOpen: false, type: '', data: null });

    const handleModalSave = (e) => {
      e.preventDefault();
      const { type, data } = modalConfig;
      const isNew = !data.id;
      const finalData = isNew ? { ...data, id: Date.now() } : data;

      if (type === 'portfolio') {
        setPortfolio(isNew ? [finalData, ...portfolio] : portfolio.map(item => item.id === data.id ? finalData : item));
      } else if (type === 'clients') {
        setClients(isNew ? [finalData, ...clients] : clients.map(item => item.id === data.id ? finalData : item));
      } else if (type === 'temoignages') {
        setTestimonials(isNew ? [finalData, ...testimonials] : testimonials.map(item => item.id === data.id ? finalData : item));
      }
      closeModal();
    };

    const handleDelete = (type, id) => {
      if (type === 'portfolio') setPortfolio(portfolio.filter(item => item.id !== id));
      if (type === 'clients') setClients(clients.filter(item => item.id !== id));
      if (type === 'temoignages') setTestimonials(testimonials.filter(item => item.id !== id));
    };

    return (
      <div className={`min-h-screen flex flex-col md:flex-row transition-colors relative ${theme === 'dark' ? 'bg-slate-950' : 'bg-slate-50'} ${isRtl ? 'rtl' : 'ltr'}`} dir={isRtl ? 'rtl' : 'ltr'}>
        
        {/* Modale d'édition globale */}
        {modalConfig.isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/80 backdrop-blur-sm">
            <div className={`w-full max-w-lg p-6 rounded-2xl shadow-2xl ${theme === 'dark' ? 'bg-slate-900 border border-slate-700' : 'bg-white border border-slate-200'}`}>
              <div className="flex justify-between items-center mb-6">
                <h3 className={`text-xl font-bold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>
                  {modalConfig.data.id ? 'Modifier' : 'Ajouter'} {modalConfig.type}
                </h3>
                <button onClick={closeModal} className="text-slate-500 hover:text-red-500"><X /></button>
              </div>
              <form onSubmit={handleModalSave} className="space-y-4">
                
                {/* Formulaire Portfolio */}
                {modalConfig.type === 'portfolio' && (
                  <>
                    <input required placeholder="Titre du projet" value={modalConfig.data.title} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, title: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    <input required placeholder="Catégorie (ex: Appartement F3)" value={modalConfig.data.subtitle} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, subtitle: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    <input required type="url" placeholder="URL de l'image de couverture" value={modalConfig.data.image} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, image: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    <input required type="url" placeholder="Lien vers la visite virtuelle (URL)" value={modalConfig.data.url} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, url: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                  </>
                )}

                {/* Formulaire Clients */}
                {modalConfig.type === 'clients' && (
                  <>
                    <input required placeholder="Nom du Client" value={modalConfig.data.name} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, name: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    <input type="url" placeholder="URL de l'image du Logo (Optionnel)" value={modalConfig.data.logo} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, logo: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    {modalConfig.data.logo && <img src={modalConfig.data.logo} alt="Aperçu" className="h-16 w-auto object-contain bg-white rounded p-2" />}
                  </>
                )}

                {/* Formulaire Témoignages */}
                {modalConfig.type === 'temoignages' && (
                  <>
                    <input required placeholder="Nom de la personne" value={modalConfig.data.author} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, author: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    <input required placeholder="Rôle (ex: Promoteur)" value={modalConfig.data.role} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, role: e.target.value } })} className={`w-full p-3 rounded-lg border ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                    <textarea required placeholder="Le message..." value={modalConfig.data.text} onChange={e => setModalConfig({ ...modalConfig, data: { ...modalConfig.data, text: e.target.value } })} className={`w-full p-3 rounded-lg border min-h-[100px] ${theme === 'dark' ? 'bg-slate-800 text-white border-slate-700' : 'bg-slate-50 border-slate-200'}`} />
                  </>
                )}

                <button type="submit" className="w-full flex items-center justify-center gap-2 bg-[#0090FF] hover:bg-blue-600 text-white font-bold py-3 rounded-lg mt-4">
                  <Save size={18} /> Sauvegarder
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Sidebar */}
        <aside className={`w-full md:w-72 md:min-h-screen flex flex-col border-r ${theme === 'dark' ? 'bg-slate-900 border-slate-800' : 'bg-white border-slate-200 shadow-sm'}`}>
          <div className={`p-6 border-b flex items-center justify-between ${theme === 'dark' ? 'border-slate-800' : 'border-slate-100'}`}>
            <div className="flex items-center gap-3">
              <LogoRenderer className="w-8 h-8 rounded-lg" />
              <span className={`text-xl font-extrabold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>Admin</span>
            </div>
            <button onClick={() => setView('public')} className={`md:hidden ${theme === 'dark' ? 'text-slate-400' : 'text-slate-500'}`}><X /></button>
          </div>
          <nav className="flex-1 p-6 space-y-3">
            <button onClick={() => setActiveTab('portfolio')} className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl font-bold transition-all ${activeTab === 'portfolio' ? 'bg-[#0090FF] text-white shadow-lg shadow-blue-500/20' : theme === 'dark' ? 'text-slate-400 hover:bg-slate-800' : 'text-slate-600 hover:bg-slate-100'}`}>
              <ImageIcon size={20} /> {t('tab_portfolio')}
            </button>
            <button onClick={() => setActiveTab('blog')} className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl font-bold transition-all ${activeTab === 'blog' ? 'bg-[#0090FF] text-white shadow-lg shadow-blue-500/20' : theme === 'dark' ? 'text-slate-400 hover:bg-slate-800' : 'text-slate-600 hover:bg-slate-100'}`}>
              <FileText size={20} /> {t('tab_blog')}
            </button>
            <button onClick={() => setActiveTab('textes')} className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl font-bold transition-all ${activeTab === 'textes' ? 'bg-[#0090FF] text-white shadow-lg shadow-blue-500/20' : theme === 'dark' ? 'text-slate-400 hover:bg-slate-800' : 'text-slate-600 hover:bg-slate-100'}`}>
              <Type size={20} /> Textes du site
            </button>
            <button onClick={() => setActiveTab('temoignages')} className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl font-bold transition-all ${activeTab === 'temoignages' ? 'bg-[#0090FF] text-white shadow-lg shadow-blue-500/20' : theme === 'dark' ? 'text-slate-400 hover:bg-slate-800' : 'text-slate-600 hover:bg-slate-100'}`}>
              <MessageSquare size={20} /> Témoignages
            </button>
            <button onClick={() => setActiveTab('clients')} className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl font-bold transition-all ${activeTab === 'clients' ? 'bg-[#0090FF] text-white shadow-lg shadow-blue-500/20' : theme === 'dark' ? 'text-slate-400 hover:bg-slate-800' : 'text-slate-600 hover:bg-slate-100'}`}>
              <Users size={20} /> Clients
            </button>
            <button onClick={() => setActiveTab('parametres')} className={`w-full flex items-center gap-4 px-5 py-4 rounded-xl font-bold transition-all ${activeTab === 'parametres' ? 'bg-[#0090FF] text-white shadow-lg shadow-blue-500/20' : theme === 'dark' ? 'text-slate-400 hover:bg-slate-800' : 'text-slate-600 hover:bg-slate-100'}`}>
              <Settings size={20} /> Paramètres
            </button>
          </nav>
          <div className={`p-6 border-t ${theme === 'dark' ? 'border-slate-800' : 'border-slate-100'}`}>
            <button onClick={() => setView('public')} className={`w-full flex items-center justify-center gap-3 px-5 py-4 rounded-xl font-bold transition-all ${theme === 'dark' ? 'text-red-400 hover:bg-red-500/10' : 'text-red-500 hover:bg-red-50'}`}>
              <LogOut size={20} /> Quitter Admin
            </button>
          </div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-8 md:p-12 overflow-y-auto">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-10 gap-4">
            <h1 className={`text-3xl font-extrabold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{t('dashboard_title')}</h1>
            
            <div className="flex items-center gap-4">
              <div className={`flex items-center rounded-lg p-1 border ${theme === 'dark' ? 'bg-slate-800 border-slate-700' : 'bg-slate-100 border-slate-200'}`}>
                {['fr', 'en', 'ar'].map(l => (
                  <button key={l} onClick={() => setLang(l)} className={`px-3 py-1 rounded-md text-xs font-bold uppercase transition-all ${lang === l ? 'bg-[#0090FF] text-white shadow-sm' : theme === 'dark' ? 'text-slate-400 hover:text-white' : 'text-slate-500 hover:text-slate-900'}`}>
                    {l}
                  </button>
                ))}
              </div>
              {/* Le bouton Ajouter n'apparaît que sur les onglets où c'est logique */}
              {['portfolio', 'clients', 'temoignages'].includes(activeTab) && (
                <button onClick={() => openModal(activeTab)} className="flex items-center justify-center gap-2 bg-[#0090FF] hover:bg-blue-600 text-white px-6 py-3 rounded-xl font-bold transition-all shadow-lg shadow-blue-500/20">
                  <Plus size={20} /> Ajouter
                </button>
              )}
            </div>
          </div>

          <div className={`rounded-2xl overflow-hidden shadow-sm border ${theme === 'dark' ? 'bg-slate-900 border-slate-800' : 'bg-white border-slate-200'}`}>
            
            {/* PORTFOLIO */}
            {activeTab === 'portfolio' && (
              <div className="overflow-x-auto">
                <table className="w-full text-left">
                  <thead className={`border-b ${theme === 'dark' ? 'bg-slate-950 border-slate-800 text-slate-400' : 'bg-slate-50 border-slate-200 text-slate-500'}`}>
                    <tr>
                      <th className="p-5 font-bold uppercase text-xs tracking-wider">Projet</th>
                      <th className="p-5 font-bold uppercase text-xs tracking-wider">Catégorie</th>
                      <th className="p-5 font-bold uppercase text-xs tracking-wider hidden md:table-cell">Lien URL</th>
                      <th className="p-5 font-bold uppercase text-xs tracking-wider text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${theme === 'dark' ? 'divide-slate-800' : 'divide-slate-100'}`}>
                    {portfolio.map(item => (
                      <tr key={item.id} className={`transition-colors ${theme === 'dark' ? 'hover:bg-slate-800/50' : 'hover:bg-slate-50'}`}>
                        <td className={`p-5 font-bold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{item.title}</td>
                        <td className={`p-5 text-sm font-medium text-[#0090FF]`}>{item.subtitle}</td>
                        <td className={`p-5 text-sm hidden md:table-cell truncate max-w-xs ${theme === 'dark' ? 'text-slate-500' : 'text-slate-400'}`}>{item.url}</td>
                        <td className="p-5 flex justify-end gap-3">
                          <button onClick={() => openModal('portfolio', item)} className={`p-2.5 rounded-lg transition-colors ${theme === 'dark' ? 'bg-slate-800 text-slate-400 hover:text-[#0090FF]' : 'bg-slate-100 text-slate-500 hover:text-[#0090FF]'}`}><Edit size={16} /></button>
                          <button onClick={() => handleDelete('portfolio', item.id)} className={`p-2.5 rounded-lg transition-colors ${theme === 'dark' ? 'bg-slate-800 text-slate-400 hover:text-red-400' : 'bg-slate-100 text-slate-500 hover:text-red-500'}`}><Trash2 size={16} /></button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            
            {/* BLOG */}
            {activeTab === 'blog' && (
              <div className="p-8 space-y-8">
                <div className={`p-6 rounded-2xl border ${theme === 'dark' ? 'bg-indigo-900/10 border-indigo-500/30' : 'bg-indigo-50 border-indigo-100'}`}>
                  <div className="flex items-center gap-3 mb-4">
                    <Sparkles className="text-indigo-500" size={24} />
                    <h3 className={`text-xl font-bold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>Assistant IA</h3>
                  </div>
                  <div className="flex flex-col sm:flex-row gap-4">
                    <input type="text" value={blogTopic} onChange={(e) => setBlogTopic(e.target.value)} placeholder="Ex: Pourquoi la visite virtuelle 360..." className={`flex-1 rounded-xl px-4 py-3 font-medium focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all ${theme === 'dark' ? 'bg-slate-800 text-white border-transparent' : 'bg-white text-slate-900 border border-slate-200 shadow-sm'}`} disabled={isGeneratingBlog} />
                    <button onClick={handleGenerateBlog} disabled={!blogTopic.trim() || isGeneratingBlog} className="flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-500 disabled:opacity-50 text-white px-6 py-3 rounded-xl font-bold whitespace-nowrap">
                      {isGeneratingBlog ? <Loader2 size={20} className="animate-spin" /> : <Sparkles size={20} />} ✨ Générer
                    </button>
                  </div>
                </div>

                <div className="space-y-6">
                  {blogPosts.filter(p => p.lang === lang).length === 0 ? (
                    <div className={`p-12 text-center rounded-2xl border border-dashed ${theme === 'dark' ? 'border-slate-700 text-slate-500' : 'border-slate-300 text-slate-400'}`}>
                      <FileText size={48} className="mx-auto mb-4 opacity-20" />
                      <p>Aucun article de blog généré pour la langue : <strong>{lang.toUpperCase()}</strong>.</p>
                    </div>
                  ) : (
                    blogPosts.filter(p => p.lang === lang).map(post => (
                      <div key={post.id} className={`p-6 rounded-2xl border shadow-sm ${theme === 'dark' ? 'bg-slate-800/50 border-slate-700' : 'bg-white border-slate-200'}`}>
                        <div className="flex justify-between items-start mb-4">
                          <h5 className={`text-lg font-bold ${theme === 'dark' ? 'text-indigo-400' : 'text-indigo-600'}`}>{post.topic}</h5>
                          <span className={`text-xs font-semibold px-3 py-1 rounded-full ${theme === 'dark' ? 'bg-slate-700 text-slate-300' : 'bg-slate-100 text-slate-500'}`}>{post.date}</span>
                        </div>
                        <div className={`text-sm whitespace-pre-wrap ${theme === 'dark' ? 'text-slate-300' : 'text-slate-700'}`}>{post.content}</div>
                        <div className="mt-4 pt-4 border-t border-slate-700/50 flex justify-end">
                           <button onClick={() => setBlogPosts(blogPosts.filter(p => p.id !== post.id))} className={`p-2 rounded-lg text-red-500 hover:bg-red-500/10`}><Trash2 size={16} /></button>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}

            {/* TEXTES */}
            {activeTab === 'textes' && (
              <div className="p-8 space-y-6">
                {['hero_title', 'hero_subtitle', 'hero_cta', 'services_title', 'portfolio_title', 'blog_title', 'blog_subtitle'].map(key => (
                  <div key={key} className="flex flex-col relative">
                    <div className="flex justify-between items-center mb-2">
                      <label className={`text-sm font-bold uppercase tracking-wide ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>{key.replace('_', ' ')}</label>
                      <button onClick={() => handleOptimizeText(key, contentDict[lang][key])} disabled={optimizingKey === key} className={`flex items-center gap-1.5 text-xs font-bold px-3 py-1.5 rounded-md ${theme === 'dark' ? 'bg-indigo-500/10 text-indigo-400' : 'bg-indigo-50 text-indigo-600'}`}>
                        {optimizingKey === key ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} />} IA
                      </button>
                    </div>
                    <textarea value={contentDict[lang][key]} onChange={(e) => handleTextUpdate(key, e.target.value)} className={`w-full rounded-xl px-4 py-3 font-medium focus:ring-[#0090FF] min-h-[80px] ${theme === 'dark' ? 'bg-slate-800 text-white border-transparent' : 'bg-slate-50 text-slate-900 border border-slate-200'}`} />
                  </div>
                ))}
              </div>
            )}

            {/* TEMOIGNAGES */}
            {activeTab === 'temoignages' && (
               <div className="overflow-x-auto">
                 <table className="w-full text-left">
                   <thead className={`border-b ${theme === 'dark' ? 'bg-slate-950 border-slate-800 text-slate-400' : 'bg-slate-50 border-slate-200 text-slate-500'}`}>
                     <tr>
                       <th className="p-5 font-bold uppercase text-xs tracking-wider">Auteur</th>
                       <th className="p-5 font-bold uppercase text-xs tracking-wider">Message</th>
                       <th className="p-5 font-bold uppercase text-xs tracking-wider text-right">Actions</th>
                     </tr>
                   </thead>
                   <tbody className={`divide-y ${theme === 'dark' ? 'divide-slate-800' : 'divide-slate-100'}`}>
                     {testimonials.map(item => (
                       <tr key={item.id} className={`transition-colors ${theme === 'dark' ? 'hover:bg-slate-800/50' : 'hover:bg-slate-50'}`}>
                         <td className={`p-5 font-bold ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{item.author}<br/><span className="text-[#0090FF] font-normal text-sm">{item.role}</span></td>
                         <td className={`p-5 text-sm ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>"{item.text}"</td>
                         <td className="p-5 flex justify-end gap-3">
                           <button onClick={() => openModal('temoignages', item)} className={`p-2.5 rounded-lg transition-colors ${theme === 'dark' ? 'bg-slate-800 text-slate-400 hover:text-[#0090FF]' : 'bg-slate-100 text-slate-500 hover:text-[#0090FF]'}`}><Edit size={16} /></button>
                           <button onClick={() => handleDelete('temoignages', item.id)} className={`p-2.5 rounded-lg transition-colors ${theme === 'dark' ? 'bg-slate-800 text-slate-400 hover:text-red-400' : 'bg-slate-100 text-slate-500 hover:text-red-500'}`}><Trash2 size={16} /></button>
                         </td>
                       </tr>
                     ))}
                   </tbody>
                 </table>
               </div>
            )}

            {/* CLIENTS */}
            {activeTab === 'clients' && (
               <div className="overflow-x-auto">
                 <table className="w-full text-left">
                   <thead className={`border-b ${theme === 'dark' ? 'bg-slate-950 border-slate-800 text-slate-400' : 'bg-slate-50 border-slate-200 text-slate-500'}`}>
                     <tr>
                       <th className="p-5 font-bold uppercase text-xs tracking-wider">Logo</th>
                       <th className="p-5 font-bold uppercase text-xs tracking-wider">Nom du Client</th>
                       <th className="p-5 font-bold uppercase text-xs tracking-wider text-right">Actions</th>
                     </tr>
                   </thead>
                   <tbody className={`divide-y ${theme === 'dark' ? 'divide-slate-800' : 'divide-slate-100'}`}>
                     {clients.map(item => (
                       <tr key={item.id} className={`transition-colors ${theme === 'dark' ? 'hover:bg-slate-800/50' : 'hover:bg-slate-50'}`}>
                         <td className="p-5">
                           {item.logo ? (
                             <img src={item.logo} alt={item.name} className="h-10 w-auto object-contain bg-white rounded p-1 shadow-sm" />
                           ) : (
                             <div className={`h-10 w-24 flex items-center justify-center text-xs border border-dashed rounded ${theme === 'dark' ? 'border-slate-600 text-slate-500' : 'border-slate-300 text-slate-400'}`}>Texte seul</div>
                           )}
                         </td>
                         <td className={`p-5 text-lg ${!item.logo ? item.style : 'font-semibold'} ${theme === 'dark' ? 'text-white' : 'text-slate-900'}`}>{item.name}</td>
                         <td className="p-5 flex justify-end gap-3">
                           <button onClick={() => openModal('clients', item)} className={`p-2.5 rounded-lg transition-colors ${theme === 'dark' ? 'bg-slate-800 text-slate-400 hover:text-[#0090FF]' : 'bg-slate-100 text-slate-500 hover:text-[#0090FF]'}`} title="Modifier logo/nom"><Edit size={16} /></button>
                           <button onClick={() => handleDelete('clients', item.id)} className={`p-2.5 rounded-lg transition-colors ${theme === 'dark' ? 'bg-slate-800 text-slate-400 hover:text-red-400' : 'bg-slate-100 text-slate-500 hover:text-red-500'}`}><Trash2 size={16} /></button>
                         </td>
                       </tr>
                     ))}
                   </tbody>
                 </table>
               </div>
            )}

            {/* PARAMETRES */}
            {activeTab === 'parametres' && (
              <div className="p-8 space-y-8">
                <div className="flex flex-col">
                  <label className={`text-sm font-bold mb-2 uppercase tracking-wide ${theme === 'dark' ? 'text-slate-400' : 'text-slate-600'}`}>
                    Logo Principal du Site
                  </label>
                  <p className={`text-sm mb-4 ${theme === 'dark' ? 'text-slate-500' : 'text-slate-500'}`}>
                    Collez le lien (URL) de votre logo (Format .png, .jpg ou .svg). Laissez ce champ vide pour utiliser l'icône vectorielle bleue par défaut.
                  </p>
                  <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-center">
                    <input type="url" value={siteLogoUrl} onChange={(e) => setSiteLogoUrl(e.target.value)} placeholder="https://exemple.com/mon-nouveau-logo.png" className={`flex-1 w-full rounded-xl px-4 py-3 font-medium focus:ring-[#0090FF] ${theme === 'dark' ? 'bg-slate-800 text-white border-transparent' : 'bg-slate-50 text-slate-900 border border-slate-200'}`} />
                    <div className={`w-24 h-24 shrink-0 rounded-2xl flex items-center justify-center border shadow-inner overflow-hidden ${theme === 'dark' ? 'bg-slate-800 border-slate-700' : 'bg-slate-100 border-slate-200'}`}>
                      <LogoRenderer className="w-16 h-16" />
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </main>
      </div>
    );
  };

  if (view === 'login') return <AdminLogin />;
  if (view === 'admin') return <AdminDashboard />;
  return <PublicSite />;
}